import { format, isToday, isTomorrow } from "date-fns";
import { fr } from "date-fns/locale";

export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatLongDate(date: Date): string {
  return capitalize(format(date, "EEEE d MMMM", { locale: fr }));
}

export function formatRelativeDay(date: Date): string {
  if (isToday(date)) return "Aujourd'hui";
  if (isTomorrow(date)) return "Demain";
  return formatLongDate(date);
}

export function formatTime(time: string): string {
  const [h, m] = time.split(":");
  return `${Number(h)}h${m}`;
}

export function formatWeekdayShort(date: Date): string {
  return capitalize(format(date, "EEE", { locale: fr }).replace(".", ""));
}

export function formatMonthShort(date: Date): string {
  return format(date, "MMM", { locale: fr }).replace(".", "");
}
